<template>
	<div class="p-fluid dashboard main-view">		
		<img alt="Logo" src="images/main_logo.png"/>
		<p class="guide" style="margin-top:20px">- 왼쪽상단의 메뉴
			<span class="pi pi-bars" style="font-size:40px"/>
		를 선택해 주세요 -
		</p>
	</div>

	<Dialog v-model:visible="isNoticeDialog" :style="{width: '1200px'}" header="공지사항" :modal="true" class="p-fluid">
		<Splitter style="height: 78vh">
            <SplitterPanel :size="50">
                <DataTable  id="dt" ref="dt" :value="noticeList" :scrollable="true" scrollHeight="750px" 
                    selectionMode="single" :metaKeySelection="false" showGridlines
                    editMode="cell" class="editable-cells-table p-datatable-sm" 
                    @rowSelect="onNoticeRowSelect" responsiveLayout="scroll">
					<template #header>
                        <i class="pi pi-calendar" style="padding:5px"></i>
                        <span>공지사항 목록</span>
                    </template>
                    <Column header="No" style="min-width:3em; max-width:3em">
                        <template #body="{index}">
                            {{ index + 1 }}
                        </template>    
                    </Column>
                    <Column field="noticeDate" header="작성일자" :sortable="true" style="min-width:110px; max-width:110px"></Column>
                    <Column field="notiDeptNm" header="공지기관" :sortable="true" style="min-width:150px; max-width:150px"></Column>
                    <Column field="title" header="제목"></Column>
                    <!--<Column field="userNm" header="작성자" style="min-width:90px; max-width:90px"></Column> -->
                </DataTable>
            </SplitterPanel>  

            <SplitterPanel :size="50">
				<div class="p-fluid">
					<div class="p-field grid">
						<div class="col-2">
							<label for="noticeDate" class="col-fixed">작성일자</label>
						</div>
						<div class="col-4">
							<InputText v-model.trim="selectedNotice.noticeDate" readonly />
						</div>
						<div class="col-2">
							<label for="fromDate" class="col-fixed" style="padding-left:0.5em;">공지기간</label>
						</div>
						<div class="col-4">
							<InputText v-model.trim="selectedNotice.period" readonly />
						</div>
					</div>
					<div class="p-field grid">
						<div class="col-2">
							<label for="userNm" class="col-fixed">작성자</label>
						</div>
						<div class="col-4">
							<InputText v-model.trim="selectedNotice.userNm" readonly/>
						</div>
						<div class="col-2">
							<label for="notiDeptNm" class="col-fixed" style="padding-left:0.5em;">공지기관</label>
						</div>
						<div class="col-4">
							<InputText v-model.trim="selectedNotice.notiDeptNm" readonly />
						</div>
					</div>
					<div class="p-field grid">
						<div class="col-2">
							<label for="telNo" class="col-fixed">연락처</label>
						</div>
						<div class="col-4">
							<InputText v-model.trim="selectedNotice.telNo" readonly/>
						</div>
						<div class="col-2">
							<label for="email" class="col-fixed" style="padding-left:0.5em;">이메일</label>
						</div>
						<div class="col-4">
							<InputText v-model.trim="selectedNotice.email" readonly/>
						</div>
					</div>
					<div class="p-field grid">
						<div class="col-2">
							<label for="title" class="col-fixed">공지제목</label>
						</div>
						<div class="col-10">
							<InputText v-model.trim="selectedNotice.title" readonly />
						</div>
					</div>
					<div class="p-field grid">
						<div class="col-2">
							<label for="notice" class="col-fixed">공지내용</label>
						</div>
						<div class="col-10">
							<Textarea v-model.trim="selectedNotice.notice" :autoResize="true" rows="7" cols="50" readonly />
						</div>
					</div>
				</div>

				<DataTable id="dt2" ref="dt2" :value="selectedNotice.attachList" v-model:selection="selectedfilesdata" showGridlines 
							:scrollable="false" scrollHeight="200px"
							class="p-datatable-sm" responsiveLayout="scroll">
					<template #header>
						<div class="flex justify-content-between flex-wrap">
                            <div class="flex align-items-center justify-content-center">
								<i class="pi pi-tag mr-2"></i>
								<span>첨부파일</span>
							</div>
                            <div class="flex align-items-center justify-content-center">
								<Button label="다운로드" icon="pi pi-download" class="p-button-sm mr-2" style="height:10px" @click="btnAct('FILE_DOWNLOAD') "/>
							</div>
                        </div>
					</template>		
					<Column header="No" style="min-width:3em; max-width:3em">
						<template #body="{index}">
							{{ index + 1 }}
						</template>    
					</Column>
					<Column selectionMode="multiple" style="min-width:3em; max-width:3em" :exportable="false"></Column>
					<Column field="originFileNm" header="파일명" headerClass="required-field"></Column>
					<Column field="fileSize" header="크기(KB)">
						<template #body="{ data, field }">
                            <span style="display: inline-block;width: 95%;">{{ formatToKB(data[field]) }}</span>
                        </template>
					</Column>
				</DataTable>
			</SplitterPanel>
        </Splitter>
	</Dialog>

</template>

<script>
import { ref, onMounted, reactive } from 'vue';
import { useToast } from 'primevue/usetoast';
import MA601070Service from '@/service/ma/MA601070Service';
import AttachFileService from '@/service/cm/AttachFileService';

export default {
	setup() {
		onMounted(() => {
            searchParams.compSeq = 1;

			// 현재 일자가 속한 공지사항 목록을 조회한다 
			noticeService.selectLatestList(searchParams).then(data => {                 
                noticeList.value = data;

				if(noticeList.value.length > 0) {
					var _params = {compSeq:noticeList.value[0].compSeq, noticeSeq:noticeList.value[0].noticeSeq, attachSeq:noticeList.value[0].attachSeq};

					// 목록에서 선택된 건에 대한 공지사항에 대한 상세정보를 얻어온다
					noticeService.getOne(_params).then(data => {
						selectedNotice.value = data;
					});
				}
            });
		})

		const toast = useToast();
		const isNoticeDialog = ref(true);
		const searchParams = reactive({});
        const noticeList = ref([]);
        const selectedNotice = ref({attachList:[{}]}); 
		const selectedfilesdata = ref([]);

		const noticeService = new MA601070Service();
		const attachFileService = new AttachFileService();

		const btnAct = (_act) =>
        {
            switch(_act)
            {
                case "FILE_DOWNLOAD":
                    filedownload();
                    break;
                default:
            }
        }

		const onNoticeRowSelect = (event) => {
            selectedNotice.value = {};

            var _params = {compSeq:event.data.compSeq, noticeSeq:event.data.noticeSeq, attachSeq:event.data.attachSeq};

            // 목록에서 선택된 건에 대한 공지사항에 대한 상세정보를 얻어온다
            noticeService.getOne(_params).then(data => {
                selectedNotice.value = data;
            });
        }

		//파일을 다운로드 한다.
        const filedownload = async () => {
            if(selectedfilesdata.value.length === 0 ){
                toast.add({severity:'error', summary: '다운로드 오류', detail: "파일을 다운로드 하기 위해서는 하나이상의 파일을 선택 해야 합니다.", life: 3000});
                return;
            }

            for(var i = 0; i < selectedfilesdata.value.length; i++){
                if(selectedfilesdata.value[i].attachSerl == null){
                    toast.add({severity:'error', summary: '다운로드 오류', detail: "저장하지 않은 파일은 다운로드 받을 수 없습니다.", life: 3000});
                    return;
                }

                var fileNm =  selectedfilesdata.value[i].originFileNm;
                var attachfile = {compSeq:selectedfilesdata.value[i].compSeq, attachSeq:selectedfilesdata.value[i].attachSeq, attachSerl:selectedfilesdata.value[i].attachSerl}

                await attachFileService.getDownload(attachfile).then((data) => {
                    const fileURL = window.URL.createObjectURL(new Blob([data]));
                    const fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', fileNm);
                    fileLink.style.cssText = 'display:none';
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    fileLink.remove(); 
                    //URL.revokeObjectURL(fileLink.href);  // URL 리소스를 지우기 위해 호출한다
                });
            }
        }
		
		// 천단위마다 콤마(,) 표시를 한다
        const formatToKB = (value) => {
            var num = Number(value).toFixed(0);
            num = Math.round(num / 1000);
            if(num == 0) num = 1;
            return num;
        }

		return { 
			searchParams, isNoticeDialog, noticeList, selectedNotice, selectedfilesdata, 
			btnAct, filedownload, onNoticeRowSelect, formatToKB
		}
	}
}
</script>

<style lang="scss" scoped>
	*,
	*:before,
	*:after{
		padding: 0;
		margin: 0;
		box-sizing: border-box;
	}

	.background{
		width: 430px;
		height: 520px;
		position: absolute;
		transform: translate(-50%,-50%);
		left: 50%;
		top: 50%;
	}
	.background .shape{
		height: 200px;
		width: 200px;
		position: absolute;
		border-radius: 50%;
	}

	.shape:first-child{
		background: linear-gradient(
			#1845ad,
			#23a2f6
		);
		left: -80px;
		top: -80px;
	}
	.shape:last-child{
		background: linear-gradient(
			to right,
			#ff512f,
			#f09819
		);
		right: -30px;
		bottom: -80px;
	}

	form{
		height: 520px;
		width: 400px;
		background-color: rgba(255,255,255,0.13);
		position: absolute;
		transform: translate(-50%,-50%);
		top: 50%;
		left: 50%;
		border-radius: 10px;
		backdrop-filter: blur(10px);
		border: 2px solid rgba(255,255,255,0.1);
		box-shadow: 0 0 40px rgba(8,7,16,0.6);
		padding: 50px 35px;
	}

	form *{
		font-family: 'Poppins',sans-serif;
		color: #ffffff;
		letter-spacing: 0.5px;
		outline: none;
		border: none;
	}

	form h3{
		font-size: 32px;
		font-weight: 500;
		line-height: 42px;
		text-align: center;
	}

	label{
		display: block;
		margin-top: 30px;
		font-size: 16px;
		font-weight: 500;
	}
	input{
		display: block;
		height: 50px;
		width: 100%;
		background-color: rgba(255,255,255,0.07);
		border-radius: 3px;
		padding: 0 10px;
		margin-top: 8px;
		font-size: 14px;
		font-weight: 300;
	}
	::placeholder{
		color: #e5e5e5;
	}

	.p-inputtext{
		display: block;
		height: 50px;
		width: 100%;
		background-color: rgba(255,255,255,0.07);
		border-radius: 3px;
		padding: 0 10px;
		margin-top: 8px;
		font-size: 14px;
		font-weight: 300;
		color: black;
		&:last-child {
            margin-bottom: 0;
        }
	}
	::placeholder{
		color: #e5e5e5;
	}

	.p-password {
		position: relative;
		display: inline-flex;
		width: 100%;
	}
	::placeholder{
		color: #e5e5e5;
	}
	::v-deep(.p-password input) {
		position: relative;
		display: inline-flex;
		height: 50px;
		width: 100%;
		background-color: rgba(255,255,255,0.07);
		border-radius: 3px;
		padding: 0 10px;
		margin-top: 8px;
		font-size: 14px;
		font-weight: 300;
		color:#e5e5e5;
	}

	.p-button {
		margin-top: 50px;
		width: 100%;
		background-color: #ffffff;
		color: #080710;
		padding: 15px 0;
		font-size: 18px;
		font-weight: 600;
		border-radius: 5px;
		cursor: pointer;

		&:not(.p-button-icon-only) {
            display: flex;
            width: 100%;
			padding-left: 10px;
			padding-right: 10px;
        }
	}

	button{
		margin-top: 50px;
		width: 100%;
		background-color: #ffffff;
		color: #080710;
		padding: 15px 0;
		font-size: 18px;
		font-weight: 600;
		border-radius: 5px;
		cursor: pointer;
	}

	.social{
		margin-top: 30px;
		display: flex;
	}
	.social div{
		width: 150px;
		border-radius: 3px;
		padding: 5px 10px 10px 5px;
		background-color: rgba(255,255,255,0.27);
		color: #eaf0fb;
		text-align: center;
	}
	.social div:hover{
		background-color: rgba(255,255,255,0.47);
	}
	.social .fb{
		margin-left: 25px;
	}
	.social i{
		margin-right: 4px;
	}

	.main-view{
		text-align: center;
		margin-top: 13%;

		.guide{
			font-size: 40px;
			font-family: 'NotoSansKR-Bold';
			color: #9D9D9D;
		}
	}

	.table-header {
		display: flex;
		align-items : center;
		justify-content: space-between;

		@media screen and (max-width: 960px) {
			align-items: start;
		}
	}

</style>